<template>
    <div :class="{ 'has-error': hasError }">
        <a
            href="#"
            @click.prevent="bookSoonestAppointment" 
            class="px-6 py-5 bg-brand-light block flex justify-between"
            :class="{'rounded mb-6': viewType === 'user', 'pointer-events-none': loading === true}"
        >
            <div>
                {{ trans('online_booking.book_soonest') }}
                <i class="zmdi zmdi-arrow-right"></i>
            </div>
            <div class="relative m-r-15" v-if="loading">
                <p class="preloader loader inset-0 absolute m-0"></p>
            </div>
        </a>
        <p
            v-if="hasError"
            class="help-block small"
            :class="viewType === 'user' ? 'pb-6' : 'py-5 px-6'"
        >
            <i class="zmdi zmdi-info-outline m-r-5"></i>
            {{ trans('online_booking.not_available') }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        viewType: {
            type: String,
            default: 'mixed', // type of calendars a user has.
            enum: ['mixed', 'user']
        },
        hasError: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        bookSoonestAppointment() {
            if (!this.loading) {
                this.$emit('bookSoonest');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .loader {
        width: 2rem;
        height: 2rem;
    }
    @media (max-width: 500px) {
        .loader {
            top: 2.25rem;
            right: 0.5rem;
        }

    }
</style>
